import React from 'react';
import clsx from 'clsx';
import { emptyTranslation } from '@colonist/i18n';
import { Image, T } from '@colonist/ui';
import styles from './ItemsTab.module.scss';
const ItemTileContents = ({ item })=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Image, {
        image: {
            src: item.imageSrc,
            alt: emptyTranslation
        }
    }), /*#__PURE__*/ React.createElement("h4", null, /*#__PURE__*/ React.createElement(T, {
        id: item.name
    })));
export const ItemsTab = ({ items, onItemClick })=>{
    if (items.length == 0) {
        return /*#__PURE__*/ React.createElement("div", {
            className: styles.itemsGrid
        }, /*#__PURE__*/ React.createElement("div", {
            className: styles.empty
        }, /*#__PURE__*/ React.createElement(T, {
            id: "strings:profilePage.items.empty.body"
        })));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.itemsGrid
    }, items.map((item)=>/*#__PURE__*/ React.createElement("div", {
            key: item.name.key,
            className: clsx(styles.itemTile, onItemClick != undefined && styles.clickable),
            onClick: onItemClick == undefined ? undefined : ()=>onItemClick(item)
        }, /*#__PURE__*/ React.createElement(ItemTileContents, {
            item: item
        }))));
};
